module.exports = __webpack_public_path__ + "static/media/postcard4thumb.363946c0.jpg";